const userGridData = [
    {
        id: 1,
        image: require('@/assets/images/brands/nmbrs.png'),
        name: 'My salary',
        text: 'Nmbrs',
        background_color: "#438FC1",
        link: "https://www.nmbrs.com/nl/inloggen",
    },
    {
        id: 2,
        image: require('@/assets/images/brands/autoentry.png'),
        name: 'My expenses',
        text: 'AutoEntry',
        background_color: "#D0072C",
        link: "https://data.autoentry.com/login2?redirect=%2Fcompanies",
    },
    {
        id: 3,
        image: require('@/assets/images/brands/absence.svg'),
        name: 'My time & absence',
        text: 'Absence',
        background_color: "#22E392",
        link: "https://app.absence.io/#/actions/login",
    },
    {
        id: 4,
        image: require('@/assets/images/brands/studytube.png'),
        name: 'My learning',
        text: 'Studytube',
        link: "https://login.studytube.nl/",
    },
    {
        id: 5,
        image: require('@/assets/images/brands/recruitee.jpg'),
        name: 'My recruitment',
        text: 'Recruitee',
        link: "https://auth.recruitee.com/",
    },
    {
        id: 6,
        image: require('@/assets/images/brands/impraise.png'),
        name: 'My performance',
        text: 'Impraise',
        link: "https://app.impraise.com/account/login",
    },
];

export {userGridData};